import {
	cancelAttributes,
	cancelPurchasesAttributes,
	confirmAttributes,
	confirmPurchasesAttributes,
	getAttributes,
	getPurchasesAttributes
} from 'actions'
import { IAttributeSale, IGetAttributesResponse } from 'models/Attributes'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import AttributesModalForm from './AttributesModalForm'
import {
	IAttributesModalProps,
	IAttributesModalState,
	IFormType
} from './AttributesTypes'

class AttributesModal extends Component<
	IAttributesModalProps,
	IAttributesModalState
> {
	constructor(props: IAttributesModalProps) {
		super(props)
		this.state = {
			attributeStateList: [],
			attribData: []
		}
	}

	componentDidMount = () => {
		const { idOperacion, it, typeForm } = this.props
		if (typeForm === IFormType.SALES) {
			this.props.getAttributes({ idOperacion, it })
		} else {
			this.props.getPurchasesAttributes({ idOperacion, it })
		}
	}

	componentDidUpdate(prevProps: Readonly<IAttributesModalProps>): void {
		const { attributeList } = this.props

		this.validateAttributeList(prevProps.attributeList, attributeList)
	}

	/**
	 * validate the list attributes when changes
	 * @param prevAttributeList
	 * @param attributeList
	 */
	validateAttributeList = (
		prevAttributeList: IGetAttributesResponse,
		attributeList: IGetAttributesResponse
	) => {
		if (
			!_.isEqual(prevAttributeList, attributeList) &&
			!_.isEmpty(attributeList)
		) {
			const attributeStateList =
				this.props.typeForm === IFormType.PURCHASES
					? this.props.attributeList.atrib_it_cpa ?? []
					: this.props.attributeList.atrib_it_vta ?? []

			this.setState({ attributeStateList })
		}
	}

	/**
	 * set data from attributes
	 * @param data
	 */
	handleChangeData = (data: Partial<IAttributeSale>) => {
		const { attribData } = this.state
		const { cod_atributo } = data

		// Find index of existing attribute with matching cod_atributo
		const existingIndex = attribData.findIndex(
			(field) => field.cod_atributo === cod_atributo
		)

		// Update attribData immutably based on whether the attribute exists or not
		const updatedAttribData =
			existingIndex !== -1
				? attribData.map((field, index) =>
						index === existingIndex ? { ...field, ...data } : field
				  )
				: [...attribData, { ...data }]

		// Update state with the new attribData
		this.setState({ attribData: updatedAttribData })
	}

	/**
	 * to confirm attributes data
	 */

	handleConfirmAttributes = () => {
		const { idOperacion, it, typeForm } = this.props
		const { attribData } = this.state
		if (typeForm === IFormType.SALES) {
			this.props.confirmAttributes({
				idOperacion,
				it,
				atrib_it_vta: attribData
			})
		} else if (typeForm === IFormType.PURCHASES) {
			this.props.confirmPurchasesAttributes({
				idOperacion,
				it,
				atrib_it_cpa: attribData
			})
		}
	}

	/**
	 * to cancel update attributes
	 */
	handleCancelAttributes = () => {
		const { idOperacion, it, typeForm } = this.props
		if (typeForm === IFormType.SALES) {
			this.props.cancelAttributes({ idOperacion, it })
		} else if (typeForm === IFormType.PURCHASES) {
			this.props.cancelPurchasesAttributes({ idOperacion, it })
		}
	}

	render() {
		const { attributeStateList } = this.state

		return (
			<AttributesModalForm
				attributeList={attributeStateList}
				handleCancelAttributes={this.handleCancelAttributes}
				handleConfirmAttributes={this.handleConfirmAttributes}
				handleChangeData={this.handleChangeData}
			/>
		)
	}
}

const mapStateToProps = ({ attributes }: any) => {
	const { attributeList } = attributes

	return { attributeList }
}

const mapDispatchToProps = {
	getAttributes,
	confirmAttributes,
	cancelAttributes,
	cancelPurchasesAttributes,
	getPurchasesAttributes,
	confirmPurchasesAttributes
}

export default connect(mapStateToProps, mapDispatchToProps)(AttributesModal)
